resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function LiveChat () {
  this.id = null;
  this.node = null;

  this._LICENSE = 8375971;
  this._LICENSE_DEV = 8555198;
  this._pollingChat = false;
  this._pollIntervalTime = 240000;
  this._pollAction = 'account.index_marketing_opt';
  this.presenter = null; // can pass in presenter for authenticated users

  this.onLoad = function noop () {};
  this.afterLoad = false;
  this.afterLoadPromise = $.Deferred();

  this.init = function () {
    this._setupLiveChat();
    this._onBeforeLoad();
    this._onAfterLoad();

    // invoke afterLoad callback if there is one, `afterLoad` callback
    // is called when afterLoadPromise is resolved in this._onAfterLoad
    // class method. At this point in time, livechat is rendered & loaded.
    $.when(this.afterLoadPromise)
      .then(function () {
        if (typeof this.afterLoad === 'function') this.afterLoad();
      }.bind(this));

    /*
      Start polling service on start to cover scenerio of visitors refreshing.

      Set up LiveChat Polling to keep visitors session alive.

      Polling Starts on Message and when clients click "Start Chat".
      Polling is done by hitting a rel link. Callback to that action determines
      if the poll should start and stop.

      Note: when chat has been closed due to long inactivity, chat_running is false.
    */
    this._onPolling = this.presenter.addCallbackToAction(
      this._pollAction,
      function (data, response) {
        // if Visitor is engaged or Chat running.
        if (window.LC_API.visitor_engaged() || window.LC_API.visitor_queued()) {
          // Event to extend analytics session.
          this._extendSessionDataLayer();
          return;
        } else {
          // stop polling
          this.presenter.stopPollAction(this._pollAction);
          this._pollingChat = false;
        };
      }.bind(this));
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    // FOR DESTROY OF LIVECHAT COMPONENT: remove  callback on action
    if (this._pollingChat === false) {
      this.presenter.removeCallbackFromAction(
        this._pollAction,
        this._onPolling
      );
    }
  };

  this._setupLiveChat = function () {
    if (window.LC_API) {
      if (window.LC_API.is_initialized) this.onLoad();
    } else {
      // setup live chat if not setup
      window.__lc = window.__lc || {};

      // Authenticated user data avail:
      if (this.presenter) {
        window.__lc.visitor = {
          name: this.presenter.getModelProperty('account.first_name') + ' ' + this.presenter.getModelProperty('account.last_name'),
          email: this.presenter.getModelProperty('account.email_address')
        };
        window.__lc.params = [
          { name: 'uuid', value: this.presenter.getModelProperty('account.uuid') }
        ];
      }

      if (window.location.host === 'www.mogo.ca') {
        window.__lc.license = this._LICENSE;
      } else {
        window.__lc.license = this._LICENSE_DEV;
      }

      // Add the script tag dynamically
      var lc = document.createElement('script');
      lc.type = 'text/javascript';
      lc.async = true;
      lc.src = 'https://cdn.livechatinc.com/tracking.js';

      $(this.node).append(lc);
    };
  };

  // Event to extend analytics session.
  this._extendSessionDataLayer = function () {
    window.dataLayer.push({
      event: 'DLevent.extendSession',
      extendSessionReason: 'Live Chat'
    });
  };

  this._updateDataLayer = function (chatEvent, chatStatus) {
    window.dataLayer = window.dataLayer || {};
    window.LC_API = window.LC_API || {};

    return function () {
      window.dataLayer.push({
        event: 'DLevent.LiveChat',
        chatEvent: chatEvent,
        chatStatus: chatStatus || window.LC_API.current_chat_state || 'No Status',
        chatID: window.LC_API.get_chat_id ? window.LC_API.get_chat_id() || 'Not Set' : 'Not Set'
      });
    };
  };

  this._setupLiveChatEventMapping = function () {
    window.LC_API = window.LC_API || {};
    window.LC_Invite = window.LC_Invite || {};

    if (window.LC_API.get_visitor_id !== null) this._updateDataLayer('Impression')();

    window.LC_API.on_ticket_created = this._updateDataLayer('Ticket Submitted');

    $(window).on('logout', function () {
      if (window.LC_API.close_chat) window.LC_API.close_chat();
    });
  };

  /* Callback function executed when LC_API object is loaded and ready to use,
     before the chat window has been rendered.
  */
  this._onBeforeLoad = function () {
    window.LC_API = window.LC_API || {};

    window.LC_API.on_before_load = function () {
      window.LC_API.is_initialized = true;
      this.onLoad();

      // Set up handlers here when LC_API object is loaded and READY to use
      this._setupLiveChatEventMapping();
      this._onPrechatSurveySubmitted();
      this._onPostchatSurveySubmitted();
      this._onRatingSubmitted();
      this._onChatStateChanged();
      this._onChatStarted();
      this._onChatEnded();
      this._onChatWindowOpened();
      this._onChatWindowMinimized();
    }.bind(this);
  };

  /* Callback function executed when LC_API object is loaded and ready to use,
     after the CHAT WINDOW has been rendered.

     this.afterLoadPromise is resolved here.
  */
  this._onAfterLoad = function () {
    window.LC_API.on_after_load = function () {
      // if the live chat is hidden show it
      if (window.LC_API.chat_window_hidden && window.LC_API.chat_window_hidden()) {
        window.LC_API.minimize_chat_window();
      }

      if (window.LC_API.visitor_engaged() || window.LC_API.visitor_queued()) {
        this._startPollAction();
      }

      // optional auto-expand chat window:
      var chatOptions = getURLParameter('chat').trim();
      if (chatOptions === 'expanded') {
        window.LC_API.open_chat_window();
      }

      this.afterLoadPromise.resolve();
    }.bind(this);
  };

  /*
      Callback function executed when the post-chat survey has been submitted by visitor.
  */
  this._onPostchatSurveySubmitted = function () {
    window.LC_API.on_postchat_survey_submitted = function (data) {
      // Visitors can submit empty survey at which data.form_data will be empty
      this._updateDataLayer(
        'Submitted: ' + ((data.form_data.length && data.form_data[0].value) ? data.form_data[0].value : 'None'),
        'Post-chat Survey')();
    }.bind(this);
  };

  /*
      Callback function executed when the pre-chat survey has been submitted by visitor.
  */
  this._onPrechatSurveySubmitted = function () {
    window.LC_API.on_prechat_survey_submitted = function (data) {
      this._updateDataLayer('Submitted: ' + data.form_data[0].value, 'Pre-chat Survey')();

      // Send the queued event from here, as on_chat_started() is not fired
      // when the visitor is siuccessfully added to the queue...
      if (window.LC_API.is_queue) this._updateDataLayer('Queue', 'Chat')();
    }.bind(this);
  };

  /*
    Callback function executed when a chat rating comment is submitted.
    The only argument, data, contains the message entered by the visitor.
  */
  this._onRatingSubmitted = function () {
    window.LC_API.on_rating_submitted = function (rating) {
      this._updateDataLayer('Rating ' + rating, 'Post-chat Survey')();
    }.bind(this);
  };

  /*
      Callback function executed when the chat state is changed.
      It accepts one argument which contains an object with the state property.

     The LC_API object is merged when LiveChat is instatiated. Create a
     property to reflect chat states returned by the on_chat_state_changed
     event (this event appears to get fired on instantiation)
  */
  this._onChatStateChanged = function () {
    window.LC_API.on_chat_state_changed = function (data) {
      window.LC_API.is_queue = data.state == 'online_for_queue';
      window.LC_API.current_chat_state = data.state == 'offline' ? 'Offline' : 'Online';
    };
  };

  /*
      Callback function executed when the chat is started.
      The only argument, data, contains additional information about the chat:
  */
  this._onChatStarted = function () {
    window.LC_API.on_chat_started = function () {
      this._updateDataLayer('Active', 'Chat')();
      this._startPollAction();
    }.bind(this);
  };

  /*
      Callback function executed when the chat is ended.
  */
  this._onChatEnded = function () {
    window.LC_API.on_chat_ended = function () {
      this._updateDataLayer('Ended', 'Chat')();
      this._stopPollAction();
    }.bind(this);
  };

  /*
      Callback function executed when the chat window is
      opened. When visitors are in queue the method on_chat_started is skipped.
      For this reason, FE have added extra check to kick off polling
  */
  this._onChatWindowOpened = function () {
    window.LC_API.on_chat_window_opened = function () {
      this._updateDataLayer('Displayed')();
      this._startPollAction();
      this._addUIContainerAdjustments();
    }.bind(this);
  };

  this._onChatWindowMinimized = function () {
    window.LC_API.on_chat_window_minimized = function () {
      this._resetUIContainerAdjustments();
    }.bind(this);
  };

  // Pull Action: Guard from calling the startPollAction more than once
  this._startPollAction = function () {
    if (!this._pollingChat && this.presenter.hasAction(this._pollAction)) {
      this.presenter.startPollAction(this._pollAction, this._pollIntervalTime, 10000);
      this._pollingChat = true;
    };
  };

  // Pull Action: Guard from calling the startPollAction more than once
  this._stopPollAction = function () {
    if (this._pollingChat && this.presenter.hasAction(this._pollAction)) {
      this.presenter.stopPollAction(this._pollAction);
      this._pollingChat = false;
    }
  };

  this.clear = function () {
    try {
      if (!window.LC_API.chat_window_maximized() && !window.LC_API.visitor_engaged()) {
        this._resetUIContainerAdjustments();
        window.LC_API.hide_chat_window();
      };
    } catch (e) {
      console.log('Live chat error: ' + e.toLocaleString());
    };
  };

  /* Hides chat bubble on the page, unless the visitor is engaged or
     chat bubble is maximized
     Usage Example: Dashboard Homepage
  */
  this.hideChatIfNotEngaged = function () {
    // LiveChat component exists outside of the Portal if it has already been created
    // Behavior: Hide chat bubble on dashboard if visitors are not engaged
    try {
      this._resetUIContainerAdjustments();
      if (!window.LC_API.chat_window_maximized() && !window.LC_API.visitor_engaged()) {
        window.LC_API.hide_chat_window();
      } else if (window.LC_API.visitor_engaged() && window.LC_API.chat_window_maximized()) {
        // Makes chatbubble visible and window maximized VS chatbubble visible and window minimized
        window.LC_API.open_chat_window();
        this._addUIContainerAdjustments();
      }
    } catch (e) {
      console.log('Live chat error: ' + e.toLocaleString());
    };
  };

  /* Minimizes chat bubble on the page, unless the visitor is engaged or
     chat bubble is maximized
     Creates LiveChat component if it's not created
     Usage Example: Card Controller, Loan Controller
  */
  this.minimizeChatOnPage = function () {
    // if object is not fully initialized wait until this (LiveChat)
    // is load and then add minimize window to onLoadCall back
    // which is called in _onAfterLoad() method.
    try {
      if (!window.LC_API.is_initialized) {
        this.onLoad(function () {
          if (window.LC_API.visitor_engaged() && window.LC_API.chat_window_maximized()) {
            this.minimizeChatWindow();
          }
        });
      } else {
        this.minimizeChatWindow();
      };
    } catch (e) {
      console.log('Live chat error: ' + e.toLocaleString());
    };
  };

  /* Minimizes chat bubble logic
  */
  this.minimizeChatWindow = function () {
    try {
      this._resetUIContainerAdjustments();
      if (window.LC_API.visitor_engaged() && window.LC_API.chat_window_maximized()) {
        window.LC_API.open_chat_window();
        this._addUIContainerAdjustments();
      } else {
        // Note: Minimize is different from hide, it "shows" the minified chat widget
        window.LC_API.minimize_chat_window();
      };
    } catch (e) {
      console.log('Live chat error: ' + e.toLocaleString());
    };
  };

  this._addUIContainerAdjustments = function () {
    // LiveChat Widget will expand to height of it's container
    // So we force the container to be 100% height
    $('#chat-widget-container').addClass('livechat--fullheight');
  };

  this._resetUIContainerAdjustments = function () {
    $('#chat-widget-container').removeClass('livechat--fullheight');
  };
}
